import {
    GET_CAN_RETURNS,
    CAN_RETURN_LOADING,
    CAN_RETURN_ERROR,
    UPDATE_CAN_RETURN
} from '../actions/types';

const initialState = {
    loading: false,
    error: null,
    canReturns: [],
    total: 0,
    pages: 0,
    counts: {}
};

export default function canReturnReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case CAN_RETURN_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_CAN_RETURNS:
            return {
                ...state,
                loading: false,
                error: null,
                canReturns: payload.canReturns || [],
                total: payload.total || 0,
                pages: payload.pages || 0,
                counts: payload.counts || {}
            };

        case UPDATE_CAN_RETURN:
            return {
                ...state,
                loading: false,
                error: null,
                canReturns: state.canReturns.map(canReturn =>
                    canReturn._id === payload._id ? payload : canReturn
                )
            };

        case CAN_RETURN_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        default:
            return state;
    }
}
